import { isStaticNav, movableNavPageThreshold, INavDot, INavState } from './navState';

function getDefaultSize (index: number, totalPages: number): string {
    if (totalPages <= movableNavPageThreshold) {
        return 'sizeL';
    }

    const defaultSizes: string[] = [
        'sizeL',
        'sizeL',
        'sizeL',
        'sizeL',
        'sizeL',
        'sizeM',
        'sizeS',
    ];

    return defaultSizes[index];
}

export function getDefaultNavState (totalPages: number): INavState {
    const totalDots: number = Math.min(totalPages, movableNavPageThreshold);

    const defaultDots = Array(totalDots).fill('').map((_, index: number): INavDot => {
        return {
            page: index + 1,
            size: getDefaultSize(index, totalPages),
            position: index + 3,
            transition: {
                enterStart: '',
                enterEnd: '',
                exit: '',
            },
        };
    });

    return {
        dots: defaultDots,
        selectedDot: 1,
        selectedPage: 1,
        inNavSelection: false,
        static: isStaticNav(totalPages),
    };
}
